import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'reactstrap';
import ArrowTop from '../../../images/arrow-back-to-top.png';
import ArrowTopWhite from '../../../images/arrow-top-white.png';

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type PopularBrands = {
  category: string;
  history: History;
};

const PopularBrands: FC<PopularBrands> = ({ category, history }) => {
  const [hovered, setHovered] = useState(false);

  const categoryUrl =
    category === 'apparels'
      ? 'apparel'
      : category === 'lifestyles'
      ? 'electronics-collectibles'
      : category === 'handbags'
      ? 'luxury'
      : category;

  const categoryUrlName =
    categoryUrl === 'electronics-collectibles'
      ? 'Electronics & Collectibles'
      : categoryUrl;

  function goToBrowseAll(category: string) {
    history.push(`/search/${category}`);
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleHover() {
    setHovered(!hovered);
  }

  return (
    <Row className="browse-all-section">
      <Col xs={10} md={9} lg={10}>
        <div className="right-side" onClick={() => goToBrowseAll(categoryUrl)}>
          <p>Browse All {categoryUrlName}</p>
        </div>
      </Col>
      <Col xs={2} md={3} lg={2}>
        <div
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
          className="left-side"
          onClick={() => scrollToTop()}
        >
          {window.screen.availWidth < 480 ? (
            <p>
              <KickImage src={ArrowTop} />
            </p>
          ) : (
            <p>
              <KickImage src={ArrowTop} /> Back to top
            </p>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PopularBrands;
